import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./TutorDashboardHeaderBanner.css";

const TutorDashboardHeaderBanner = () => {
  const [screenType, setScreenType] = useState(getScreenType());

  function getScreenType() {
    if (window.innerWidth > 1400) return "large";
    if (window.innerWidth >= 768) return "desktop";
    return "mobile";
  }

  useEffect(() => {
    const handleResize = () => setScreenType(getScreenType());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let svgList = [];

  if (screenType === "large") {
    svgList = [
      "./tutor-dashboard-header-banner-large-1.svg",
      "./tutor-dashboard-header-banner-large-2.svg",
      "./tutor-dashboard-header-banner-large-3.svg",
      "./tutor-dashboard-header-banner-large-4.svg",
    ];
  } else if (screenType === "desktop") {
    svgList = [
      "./tutor-dashboard-header-banner-1.svg",
      "./tutor-dashboard-header-banner-2.svg",
      "./tutor-dashboard-header-banner-3.svg",
      "./tutor-dashboard-header-banner-4.svg",
    ];
  } else {
    svgList = [
      "./tutor-dashboard-header-banner-mobile-1.png",
      "./tutor-dashboard-header-banner-mobile-2.png",
      "./tutor-dashboard-header-banner-mobile-3.png",
      "./tutor-dashboard-header-banner-mobile-4.png",
    ];
  }

  return (
    <div className={`carousel-container ${screenType}`}>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
      >
        {svgList.map((src, idx) => (
          <SwiperSlide key={idx}>
            <img src={src} alt={`Slide ${idx + 1}`} className="slide-image" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TutorDashboardHeaderBanner;
